import { useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { clsx } from 'clsx';

interface IBigTitleProps {
  text: string;
}

export const BigTitle: React.FC<IBigTitleProps> = ({ text }) => {
  const device = useDeviceType();

  return <div className={clsx(styles['title'], styles[device])}>{text}</div>;
};
